export default __webpack_public_path__ + "030c9180b97943e778d2ccaa08b1642f.jpg";